/**
 * @generated SignedSource<<7b0cc6583e90d8a75c43411e149035fe>>
 * @relayHash d147836e60ff51352bf0f1bd546feca4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 35c4ec47efcd810b834eb6c04bc90699cf30d4bbbb478bcec9631cca76a4c516

import type { ConcreteRequest } from 'relay-runtime';
export type useMigratedRecentlyMigratedRecentlyQuery$variables = {
  contentId: string;
};
export type useMigratedRecentlyMigratedRecentlyQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly metadata: {
        readonly frontend: {
          readonly migratedRecently: boolean | null | undefined;
        } | null | undefined;
      };
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useMigratedRecentlyMigratedRecentlyQuery = {
  response: useMigratedRecentlyMigratedRecentlyQuery$data;
  variables: useMigratedRecentlyMigratedRecentlyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "migratedRecently"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useMigratedRecentlyMigratedRecentlyQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMigratedRecentlyMigratedRecentlyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d147836e60ff51352bf0f1bd546feca4",
    "id": "35c4ec47efcd810b834eb6c04bc90699cf30d4bbbb478bcec9631cca76a4c516",
    "metadata": {},
    "name": "useMigratedRecentlyMigratedRecentlyQuery",
    "operationKind": "query",
    "text": "query useMigratedRecentlyMigratedRecentlyQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{frontend{migratedRecently}}}}}"
  }
};
})();

(node as any).hash = "b40f774bad57acf133d091b1d654a206";

export default node;
